// Full-document render of the embeddable footer-only fragment
// (FooterIFrameView). PageSkeleton renders the site footer but omits the header
// and the <main> wrapper, and suppresses the flash-messages aside -- matching
// the legacy footer-iframe.html which blanked {% block header %} (and with it
// the messages include). OneTrust/GTM stay (the dead {% block onetrust %}
// override in stearns.html was a no-op); zendesk is dropped via the view's
// chat_widget_enabled=False. Unlike the nav fragment there is no iFrameResizer
// config object (parity with the legacy template).
import React from "react";

import { Context, templates } from "@reactivated";

import { useSSRNonce } from "@thelabnyc/thelabui/src/hooks/useSSRNonce";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.FooterIFrameDocumentTemplate,
): React.JSX.Element => {
    const staticBase = React.useContext(Context).chrome.static_base;
    const nonce = useSSRNonce();
    return (
        <PageSkeleton
            pageChrome={props.page_chrome}
            header={false}
            messages={false}
            wrapMain={false}
        >
            <script
                src={`${staticBase}dist2/iframe-resizer/iframeResizer.contentWindow.js`}
                nonce={nonce}
                suppressHydrationWarning={true}
            />
        </PageSkeleton>
    );
};
